import { EventEmitter, Injectable } from '@angular/core';
import { ZONE } from '../zone/zone.service';

@Injectable({
  providedIn: 'root'
})
export class VehicleService {

  is_display_vehicle_register_component = false;
  vehicleUpdate = new EventEmitter<ZONE>();

  downloadVehicle = new EventEmitter<boolean>();

  private _vehicle_data: VEHICLE = null;

  constructor() { }

  set set_vehicle_data(_vehicle_data) {
    this._vehicle_data = _vehicle_data;
  }

  get get_vehicle_data_data() {
    return this._vehicle_data;
  }

}

export interface VEHICLE {
  id: number;
  name: string;
}
